<template>
  <div class="w-1200" style="padding-bottom: 40px">
    <div class="title">立即购买</div>
    <div class="body-content">
      <div class="inner">
        <div class="address-title">
          <span class="desc-name">收货地址</span>
          <el-button type="text" @click="addressAddDialog = true"><i class="el-icon-plus"></i> 新增收货地址</el-button>
        </div>
        <div class="inner-box">
          <div class="tag-box" v-if="defaultAddress">
            <el-radio class="radio-item" v-model="radio1" label="1" border>
              <div class="radio-box-item">
                <div class="radio-box">
                  <div class="radio-box-top">
                    <span>{{ defaultAddress.name }}</span>
                    <span>{{ defaultAddress.phone }}</span>
                  </div>
                  <div class="radio-box-fotter">
                    <span>{{ defaultAddress.province }} {{ defaultAddress.city }}
                      {{ defaultAddress.area }}
                      {{ defaultAddress.address }}</span>
                  </div>
                </div>
              </div>
            </el-radio>
          </div>
          <el-collapse v-model="activeNamesAddress">
            <el-collapse-item name="2">
              <template slot="title">
                {{
                  activeNamesAddress.includes("2")
                      ? "收起所有地址"
                      : "展开所有地址"
                }}<i class="el-icon-arrow-down"></i>
              </template>
              <el-radio-group v-model="addressRadio" @input="handleChangeAddress">
                <div class="tag-box">
                  <el-radio class="radio-item" v-for="item in addressList" :key="item.id" :label="item.id" border>
                    <div class="radio-box-item">
                      <div class="radio-box">
                        <div class="radio-box-top">
                          <span>{{ item.name }}</span>
                          <span>{{ item.phone }}</span>
                        </div>
                        <div class="radio-box-fotter">
                          <span>{{ item.province }} {{ item.city }}
                            {{ item.area }} {{ item.address }}</span>
                        </div>

                      </div>
                      <div class="radio-box-item-footer">
                        <div class="radio-box-item-footer-top">
                          <el-button type="text" @click="handleEditAddress(item)">编辑</el-button>
                          <el-button type="text" @click="handleDeleteAddress(item)">删除</el-button>
                        </div>
                        <input @click="handleDefaultAddress(item)" type="radio" name="group_name" :value="item.id"
                               :checked="item.is_default==1" :id="item.id">
                        <label :for="item.id">默认地址</label>
                      </div>
                    </div>
                  </el-radio>
                </div>
              </el-radio-group>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div class="inner">
        <div class="address-title">
          <span class="desc-name">发票抬头</span>
          <el-button type="text" @click="invoicingAddClose(true)"><i class="el-icon-plus"></i> 新增发票抬头</el-button>
        </div>
        <div class="inner-box">
          <div class="tag-box" v-if="defaultInvoice">
            <el-radio class="radio-item" v-model="radio1" label="1" border>
              <div class="radio-box-item">
                <div class="radio-box">
                  <div class="radio-box-top">
                    <span>{{ defaultInvoice.title }}</span>
                    <span>{{ defaultInvoice.tax_number }}</span>
                  </div>
                  <div class="radio-box-fotter">
                    <span>{{ defaultInvoice.address || '' }}</span>
                  </div>
                </div>
<!--                <div class="default-address">默认抬头</div>-->
              </div>
            </el-radio>
          </div>
          <el-collapse v-model="activeNames">
            <el-collapse-item name="1">
              <template slot="title">
                {{
                  activeNames.includes("1")
                      ? "收起所有发票抬头"
                      : "展开所有发票抬头"
                }}<i class="el-icon-arrow-down"></i>
              </template>
              <el-radio-group v-model="invoiceRadio" @input="handleChangeInvoice">
                <div class="tag-box">
                  <el-radio class="radio-item" v-for="item in invoiceList" :key="item.id" :label="item.id" border>
                    <div class="radio-box-item">
                      <div class="radio-box">
                        <div class="radio-box-top">
                          <span>{{ item.title }}</span>
                          <span>{{ item.tax_number }}</span>
                        </div>
                        <div class="radio-box-fotter">
                          <span>{{ item.address || '' }}</span>
                        </div>
                      </div>
                      <div class="radio-box-item-footer">
                        <div class="radio-box-item-footer-top">
                          <el-button type="text" @click="handleEditInvoice(item)">编辑</el-button>
                          <el-button type="text" @click="handleDeleteInvoice(item)">删除</el-button>
                        </div>
                      </div>
                    </div>
                  </el-radio>
                </div>
              </el-radio-group>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div class="table-box">
        <div class="title-box">确认订单信息</div>
        <div class="table-inner">
          <el-table :data="orderDetail" style="width: 100%" :header-cell-style="{
            backgroundColor: '#F6F6F8',
            color: '#999999',
          }">
            <el-table-column prop="product_name" label="商品名称"/>
            <el-table-column prop="cas_no" label="CAS"/>
            <el-table-column label="规格">
              <div slot-scope="scope">
                <span>{{ scope.row.number }}</span>
                <span>{{ scope.row.unit }}</span>
              </div>
            </el-table-column>
            <el-table-column prop="custorm_price" v-if="!isVip" label="单价"/>
            <el-table-column prop="total_price" v-if="isVip" label="单价"/>
            <el-table-column label="小计">
              <div>
                <span class="all-price"> {{ allPrice }}</span>
                <span class="all-price-unit">元</span>
              </div>
            </el-table-column>
            <el-table-column label="发票类型">
              专票
            </el-table-column>
          </el-table>
        </div>
        <div class="table-box">
          <div class="title-box remark-title">备注</div>
          <el-input v-model="remark" type="textarea" placeholder="请输入备注">
          </el-input>
        </div>
        <div class="table-footer">
          <span class="table-footer-text">合计金额：</span>
          <span class="table-footer-price" v-if="orderDetail[0]">￥{{ allPrice }}</span>
        </div>
        <div class="table-footer">
          <span class="table-footer-text">实付款：</span>
          <span class="table-footer-big" v-if="orderDetail[0]">￥{{ allPrice }}</span>
        </div>
      </div>
      <div class="table-button">
        <gradient-button height="40px" width="150px" border="1px solid #336ED2" background="#E9F1FE" color="#0C60E6"
                         @hit="handleBack">返回上一步
        </gradient-button>
        <gradient-button @hit="handleSubmit" height="40px" width="150px" background="#0C60E6">提交订单</gradient-button>
      </div>
    </div>
    <add-addresss :id="editAddressId" :addressAddDialog="addressAddDialog" @close="addressAddClose"
                  @success="addressSuccess"/>
    <add-invoicing :invoicingeAddDialog="invoicingAddDialog" @close="invoicingAddClose" @success="invoicingSuccess" :id="invoicingId"/>
  </div>
</template>
<script>
import {
  order_buy,
  getUserAddress,
  invoiceList,
  quote_detail_d,
  addressUpdate,
  addressDelete, invoiceDelete
} from "@/api/modules/user";
import gradientButton from "@/components/button/gradient-button.vue";
import {getDefault, getInvoice} from "@/api/modules/common";

import addAddresss from "@/components/addInfo/add_addresss.vue";
import addInvoicing from "@/components/addInfo/add_invoicing.vue";

export default {
  name: "bay",
  components: {
    gradientButton,
    addAddresss,
    addInvoicing,
  },
  data() {
    return {
      invoicingId: '',
      id: this.$route.query.id,
      activeNames: [""],
      activeNamesAddress: [""],
      // 默认地址
      defaultAddress: null,
      // 默认发票
      defaultInvoice: null,
      // 添加地址弹窗
      addressAddDialog: false,
      // 添加发票弹窗
      invoicingAddDialog: false,
      // 地址列表
      addressList: [],
      // 发票列表
      invoiceList: [],
      // 地址radio
      addressRadio: "",
      // 发票radio
      invoiceRadio: "",
      // 订单详情
      orderDetail: [],
      radio1: "1",
      remark: "",
      num: 1,
      editAddressId: '',
    };
  },
  computed: {
    isVip() {
      return this.$store.getters.is_vip;
    },
    allPrice() {
      if (this.orderDetail[0]) {
        if (this.isVip) {
          return (Number(this.orderDetail[0].total_price) * this.num).toFixed(2);
        } else {
          return (Number(this.orderDetail[0].custorm_price) * this.num).toFixed(2);
        }
      }
      return 0;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    handleEditInvoice(item) {
      this.invoicingId = item.id
      this.invoicingAddDialog = true;
    },
    handleDeleteInvoice(item) {
      this.$confirm('确定删除该发票吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        invoiceDelete(item.id).then((res) => {
          if (res.data.code == 10000) {
            this.$message.success({
              message: "删除成功",
              type: "success",
              offset: 300,
            });
            this.getInvoiceList()
          } else {
            this.$message.error({
              message: res.data.message,
              type: "error",
              offset: 300,
            });
          }
        })
      })

    },
    handleDeleteAddress(item) {
      if (item.is_default) {
        this.$message.error({
          message: "默认地址不能删除",
          type: "error",
          offset: 300,
        });
        return
      }
      if (this.addressRadio == item.id) {
        this.$message.error({
          message: "当前地址不能删除",
          type: "error",
          offset: 300,
        });
        return
      }
      this.$confirm('确定删除该地址吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        addressDelete(item.id).then((res) => {
          if (res.data.code == 10000) {
            this.$message.success({
              message: "删除成功",
              type: "success",
              offset: 300,
            });
            this.getAddressList();
          }
        })
      })
    },
    handleEditAddress(item) {
      this.addressAddDialog = true;
      this.editAddressId = item.id;
    },
    handleDefaultAddress(item) {
      let data = {
        district: [item.provinceId, item.cityId, item.areaId],
        address: item.address,
        is_default: 1,
        name: item.name,
        phone: item.phone,
      }
      addressUpdate(item.id, data).then((res) => {
        if (res.data.code == 10000) {
          this.$message.success({
            message: "设置成功",
            type: "success",
            offset: 300,
          });
        } else {
          this.$message.error({
            message: res.data.message,
            type: "error",
            offset: 300,
          });
        }
      });

    },
    handleChangeNum(row) {
      this.num = row.num;
    },
    // 提交订单
    handleSubmit() {
      if (!this.addressRadio) {
        this.$message.error({
          message: "请选择收货地址",
          type: "error",
          offset: 100,
        });
        return;
      }
      if (!this.invoiceRadio) {
        this.$message.error({
          message: "请选择发票",
          type: "error",
          offset: 100,
        });
        return;
      }
      order_buy({
        quote_id: this.id,
        address_id: this.addressRadio,
        invoice_id: this.invoiceRadio,
        remark: this.remark,
      }).then((res) => {
        if (res.data.code === 10000) {
          this.$message.success({
            message: "提交订单成功",
            type: "success",
            offset: 100,
          });
          this.$router.push({
            path: "/shop/bay",
            query: {
              order_id: res.data.data,
            },
          });
          // this.$router.push({
          //   name: "/shop/bay",
          //   params: {
          //     order_id: res.data.data,
          //   },
          // });
        }
      });
    },
    addressSuccess() {
      this.getAddressList();
      this.getAddress();
      this.editAddressId = ''
    },
    invoicingSuccess() {
      this.getInvoiceList();
      this.getInvoice();
    },
    // 切换地址
    handleChangeAddress(e) {
      // 设置默认地址
      this.defaultAddress = this.addressList.find((item) => item.id === e);
    },
    // 切换发票
    handleChangeInvoice(e) {
      this.defaultInvoice = this.invoiceList.find((item) => item.id === e);
    },
    addressAddClose(e) {
      this.addressAddDialog = e;
    },
    invoicingAddClose(e) {
      this.invoicingAddDialog = e;
    },
    init() {
      this.getAddress();
      this.getInvoice();
      this.getAddressList();
      this.getInvoiceList();
      // 获取订单详情
      this.getOrderDetail();
    },
    // 获取订单详情
    getOrderDetail() {
      quote_detail_d(this.id).then((res) => {
        if (res.data.code === 10000) {
          this.orderDetail = [res.data.data];
          this.orderDetail[0].num = 1;
        } else {
          this.$message.error({
            message: res.data.msg,
            type: "error",
            offset: 100,
          });
        }
      });
    },
    // 获取默认发票
    getInvoice() {
      getInvoice().then((res) => {
        if (res.data.data) {
          this.defaultInvoice = res.data.data;
          this.invoiceRadio = res.data.data.id;
        }
      });
    },
    // 获取默认地址
    getAddress() {
      getDefault().then((res) => {
        if (res.data.data) {
          this.addressRadio = res.data.data.id;
          this.defaultAddress = res.data.data;
        }
      });
    },
    // 获取地址列表
    getAddressList() {
      getUserAddress().then((res) => {
        this.addressList = res.data.data.data;
      });
    },
    // 获取发票列表
    getInvoiceList() {
      invoiceList().then((res) => {
        this.invoiceList = res.data.data.data;
      });
    },

    // 返回上一步
    handleBack() {
      this.$router.back();
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-radio__label {
  width: 100% !important;
}

::v-deep .el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 0 !important;
}

::v-deep .el-collapse-item__header {
  border-bottom: none !important;
}

::v-deep .el-radio {
  margin-right: 0 !important;
}

::v-deep .el-radio-button__inner,
.el-radio-group {
  display: block !important;
}

.remark-title {
  padding: 20px 0;
}

.title {
  font-weight: 800;
  font-size: 24px;
  color: #00112b;
  margin: 40px 0 20px;
}

.body-content {
  padding: 0 20px 30px;
  background-color: #ffffff;

  .inner {
    .address-title {
      padding: 30px 0;

      .desc-name {
        font-weight: bold;
        font-size: 18px;
        color: #00112b;
        display: inline-block;
        margin-right: 24px;
      }
    }

    .inner-box {
      .tag-box {
        display: flex;
        flex-direction: column;
        gap: 20px;

        .radio-item {
          height: 98px;
          background: rgba(12, 96, 230, 0.06);
          display: flex;
          align-items: center;
          padding: 0 40px;
        }

        .default-address {
          font-weight: 400;
          font-size: 18px;
          color: #afafaf;
        }

        .radio-box-item {
          flex: 1;
          display: flex;
          width: 100%;
        }

        .radio-box {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding-left: 24px;
          gap: 10px;

          .radio-box-top {
            display: flex;
            font-weight: bold;
            font-size: 18px;
            color: #333333;
            gap: 15px;
          }

          .radio-box-fotter {
            font-weight: 400;
            font-size: 18px;
            color: #5f616c;
          }
        }
      }
    }
  }

  .table-button {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    margin-top: 20px;
  }

  .table-box {
    .title-box {
      font-weight: bold;
      font-size: 18px;
      color: #00112b;
    }

    .table-inner {
      border: 1px solid #eeeeee;
      margin-top: 20px;

      .all-price {
        font-weight: bold;
        font-size: 18px;
        color: #ff4400;
      }

      .all-price-unit {
        font-weight: bold;
        font-size: 16px;
        color: #ff4400;
      }
    }

    .table-footer {
      text-align: right;
      padding-top: 25px;

      .table-footer-text {
        font-weight: 400;
        font-size: 18px;
        color: #5f616c;
      }

      .table-footer-price {
        font-weight: bold;
        font-size: 18px;
        color: #ff4400;
      }

      .table-footer-big {
        font-weight: bold;
        font-size: 26px;
        color: #ff4400;
      }
    }
  }
}
</style>
